import { useEffect } from "react";
import axios from "axios";
import { isEnPath, toEnPath, toTrPath } from "../langRouting";
import { useLang } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Canonical + og:url + hreflang yönetimi (SPA'da rota bazlı, TR/EN ayna çiftleriyle)
export function setCanonical(path) {
  const current = path || window.location.pathname;
  const trPath = toTrPath(current);
  const enPath = toEnPath(trPath);
  const selfHref = `https://parasyo.com${current}`;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", selfHref);
  setMeta("property", "og:url", selfHref);
  // hreflang: tr, en ve x-default her sayfada birbirine bağlanır
  [
    ["tr", `https://parasyo.com${trPath}`],
    ["en", `https://parasyo.com${enPath}`],
    ["x-default", `https://parasyo.com${trPath}`],
  ].forEach(([hl, href]) => {
    let link = document.head.querySelector(`link[rel="alternate"][hreflang="${hl}"]`);
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "alternate");
      link.setAttribute("hreflang", hl);
      document.head.appendChild(link);
    }
    link.setAttribute("href", href);
  });
}

// Sayfa tipine göre JSON-LD şeması ekler (id ile tekil, unmount'ta temizlenir)
export function setJsonLd(id, data) {
  document.getElementById(`ld-${id}`)?.remove();
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = `ld-${id}`;
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}

export function removeJsonLd(id) {
  document.getElementById(`ld-${id}`)?.remove();
}

export function useSeo(slug) {
  const { lang } = useLang();

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/seo/${slug}`)
      .then((r) => {
        if (cancelled) return;
        const seo = r.data?.seo || {};
        const title = (lang === "en" ? seo.meta_title_en : seo.meta_title_tr) || r.data?.[`title_${lang}`];
        const desc = lang === "en" ? seo.meta_description_en : seo.meta_description_tr;
        if (title) {
          document.title = title;
          setMeta("property", "og:title", title);
          setMeta("name", "twitter:title", title);
        }
        setMeta("name", "description", desc);
        setMeta("property", "og:description", desc);
        setMeta("property", "og:locale", lang === "en" ? "en_US" : "tr_TR");
        setMeta("property", "og:locale:alternate", lang === "en" ? "tr_TR" : "en_US");
        setMeta("name", "twitter:description", desc);
        setMeta("name", "keywords", seo.keywords);
        setMeta("property", "og:image", seo.og_image);
        setMeta("name", "twitter:image", seo.og_image || "https://parasyo.com/assets/brand/parasyo-og.png");
        setMeta("name", "robots", seo.noindex ? "noindex, nofollow" : "index, follow");
        // Self-canonical: her dil aynası kendi URL'sine işaret eder (/en dahil)
        setCanonical(window.location.pathname);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [slug, lang]);
}
